import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import Swal from "sweetalert2";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DeliveryAddressSelector from "./DeliveryAddressSelector";

/**
 * Genera una nueva guía de Interrapidísimo para una orden devuelta.
 * Se puede elegir la dirección actual, otra guardada o una nueva; el backend
 * recotiza y registra el flete como "cobro de reenvio por devolución".
 */
export const ReshipOrderModal = ({ order, isOpen, toggle, onDone }) => {
  const { getData, postData } = useDataFetch();
  const userId = order.user_id?._id || order.user_id?.id || order.user_id;

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [shipping, setShipping] = useState(undefined);
  const [shippingCost, setShippingCost] = useState(0);

  const { data, isLoading: loadingAddresses } = getData(
    ["addressesByUser", userId],
    `/address/byUserDash/${userId}`,
    { enabled: isOpen && !!userId }
  );
  const addresses = data?.data?.addresses || [];

  const { mutate, isPending } = postData(`/order/${order._id || order.id}/reship`, {}, {
    onSuccess: (response) => {
      Swal.fire(
        "Guía generada",
        `Nueva guía: ${response.data.guide}. Cobro de reenvío por devolución: $${response.data.value.toLocaleString()}`,
        "success"
      );
      toggle();
      onDone?.();
    },
    onError: (error) => Swal.fire("Error", error.message, "error"),
  });

  const current = order.shipping_address;
  const selectedProducts = (order.items || []).map((item) => ({
    productId: item.product_id?._id || item.product_id?.id || item.product_id,
    quantity: item.quantity,
  }));

  const handleConfirm = () =>
    mutate({
      address_id: selectedAddress || undefined,
      shipping: selectedAddress ? undefined : shipping,
    });

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered backdrop="static">
      <ModalHeader toggle={toggle}>Reenvío por devolución</ModalHeader>
      <ModalBody>
        {current && (
          <p className="mb-2">
            <strong>Dirección actual:</strong> {current.address}, {current.city?.name},{" "}
            {current.province?.name}. Selecciónala para reenviar sin cambios.
          </p>
        )}

        <DeliveryAddressSelector
          addresses={addresses}
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          loadingAddresses={loadingAddresses}
          setShipping={setShipping}
          selectedUser={{ value: userId }}
          setShippingCost={setShippingCost}
          selectedProducts={selectedProducts}
          shippingCost={shippingCost}
          carrier="interrapidisimo"
          setCarrier={() => {}}
          carrierLocked
        />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={isPending}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={isPending || !(shippingCost > 0)}>
          {isPending && <Spinner size="sm" className="me-2" />}
          Generar nueva guía
        </Button>
      </ModalFooter>
    </Modal>
  );
};
